<template>    
</template>

<script>

    import '@/assets/scripts/jquery-3.3.1.min.js'
    import '@/assets/scripts/jquery.signalR-2.2.2.min.js'

    export default {
        beforeCreate () {

            // Set local variables
            var baseUrl = window.app.config.baseUrl;
            var url = baseUrl.substring(0, baseUrl.length - 4);
            let preOrderConcurrencyServerurl = url + "signalr";             

            /* ----- Create PreOrderConcurrencyhub Proxy ----- */
            // Check if SignalR is loaded correctly;
            if (typeof ($.signalR) !== "function") console.log("SignalR: SignalR is not loaded.");

            let signalR = $.signalR;

            // Function to make the client callbacks
            function makeProxyCallback (hub, callback) {
                return function () {
                    callback.apply(hub, $.makeArray(arguments));
                };
            }

            function registerHubProxies (instance, shouldSubscribe) {
                let key, hub, memberKey, memberValue, subscriptionMethod;

                for (key in instance) {

                    if (instance.hasOwnProperty(key)) {
                        hub = instance[key];

                        if (!(hub.hubName)) continue;

                        if (shouldSubscribe) {
                            subscriptionMethod = hub.on;
                        } else {
                            subscriptionMethod = hub.off;
                        }

                        for (memberKey in hub.client) {
                            if (hub.client.hasOwnProperty(memberKey)) {

                                memberValue = hub.client[memberKey];

                                if (!$.isFunction(memberValue)) continue;

                                subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue));
                            }
                        }
                    }
                }
            }

            $.hubConnection.prototype.createHubProxies = function () {
                let proxies = {};
                this.starting(function () {
                    registerHubProxies(proxies, true);
                    this._registerSubscribedHubs();
                }).disconnected(function () {
                    registerHubProxies(proxies, false);
                });

                proxies['preOrderConcurrencyHub'] = this.createHubProxy('preOrderConcurrencyHub');
                proxies['preOrderConcurrencyHub'].client = {};
                proxies['preOrderConcurrencyHub'].server = {
                    joinConcurrency: function (preOrderId) {
                        return proxies['preOrderConcurrencyHub'].invoke.apply(proxies['preOrderConcurrencyHub'], $.merge(["JoinConcurrency"], $.makeArray(arguments)));
                    },
                };

                return proxies;
            };

            signalR.hub = $.hubConnection(preOrderConcurrencyServerurl, {useDefaultPath: false});
            $.extend(signalR, signalR.hub.createHubProxies());
        },
        created() {
            let preOrderId = this.$route.params.id;
            $.connection.hub.qs = {'access_token': localStorage.getItem('ra_token')};
            let preOrderConcurrency = $.connection.preOrderConcurrencyHub;
            
            // Bind functions to client Callbacks
            preOrderConcurrency.client.checkConcurrency = this.checkConcurrency;

            $.connection.hub.start().done(function () {
                preOrderConcurrency.server.joinConcurrency(preOrderId);
            }).fail(function () {
                console.log("Connection could not be made, please contact your administrator");
            });
        },
        data () {
            return {
                preOrderConcurrencyServerurl: String,
            }
        },
        methods: {
            /* --- Callbacks ---*/
            checkConcurrency (userId) {
                if(userId !== localStorage.getItem('ra_userid')){
                    this.$emit('concurrencyException');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/concurrency/PreOrderConcurrencyManager.vue